import { render, staticRenderFns } from "./goBuckreupRD.vue?vue&type=template&id=15c8aab5"
import script from "./goBuckreupRD.vue?vue&type=script&lang=js"
export * from "./goBuckreupRD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports